const cryptoFormat = new Intl.NumberFormat('en-GB', { style: 'decimal', maximumFractionDigits: 8 });

$('#prodSelect').change(function () {
    $.post("/resources/proof-of-holdings/on-chain-wallet-verification/gen-data.php", { 'fund_key': $(this).val() }, function (data) {
        swapData(data);
        renderChart();
    });
})

$(document).ready(() => {
    renderChart();
})

function swapData(data) {
    let decoded = jQuery.parseJSON(data);

    for (key in decoded.prod_data) {
        $(`[data-prod=${key}]`).html(decoded.prod_data[key]);
        $(`[data-chart=${key}]`).val(decoded.prod_data[key]);
    }

    $(`[data-prod=total_sum]`).text(decoded.prod_sum);
    $('[data-wallets]').html(genList());

    function genList() {
        let htmlTempl = '';
        $('.custody__title h3').html(decoded.message);
        if (decoded.is_hidden_by_us) {
            $('.hidden_by_us').removeClass('disable_hidden');
            htmlTempl = '';
        } else {
            $('.hidden_by_us').addClass('disable_hidden');
            for (key of decoded.prod_wallets) {
                htmlTempl += `
            <div class="wallet">
                <div class="d-flex">
                    <span>${key.address}</span>
                    <div class="wallet__copy">
                        <a href="${key.link}" class="btn btn-filled btn-sm btn-icon-left btn-icon-external" target="_blank">open</a>
                        <button class="btn btn-filled btn-sm btn-icon-left btn-icon-copy" data-clipboard="${key.address}" data-container="body" data-toggle="popover" data-placement="top" data-content="Copied to clipboard">copy</button>
                    </div>
                </div>
                <span>${key.balance + ' ' + decoded.prod_data['symbol']}</span>
            </div>
            `
            }
        }
        return htmlTempl;
    }
}

function renderChart() {
    const chartContainer = $('#proofsChart');
    const color = $('[data-chart=color]').val();
    const required_collateral_raw = Number($('[data-chart=required_collateral_raw]').val()).toFixed(8);
    const collateral_held_raw = Number($('[data-chart=collateral_held_raw]').val()).toFixed(8);
    const symbol = $('[data-chart=symbol]').val();
    const reqLegText = $('[data-chart=req_leg_text]').val();
    const holdLegText = $('[data-chart=hold_leg_text]').val();
    const reqColText = $('[data-chart=req_col_text]').val();
    const holdColText = $('[data-chart=hold_col_text]').val();

    let chartStatus = Chart.getChart("proofsChart");

    if (chartStatus != undefined) {
        chartStatus.destroy();
    };

    const data = {
        labels: [''],
        datasets: [
            {
                xLabel: reqColText,
                label: reqLegText,
                backgroundColor: color,
                data: [required_collateral_raw],
                borderRadius: {
                    'topLeft': 5,
                    'topRight': 5
                },
                barPercentage: 0.9,
                maxBarThickness: 274
            },
            {
                xLabel: holdColText,
                label: holdLegText,
                backgroundColor: '#9DDECA',
                data: [collateral_held_raw],
                borderRadius: {
                    'topLeft': 5,
                    'topRight': 5
                },
                barPercentage: 0.9,
                maxBarThickness: 274
            },
        ]
    }


    const chart = new Chart(
        chartContainer,
        {
            type: 'bar',
            data: data,
            options: {
                maintainAspectRatio: false,
                responsive: true,
                devicePixelRatio: 2,
                layout: {
                    padding: {
                        left: 10
                    }
                },
                scales: {
                    x: {
                        display: false,
                        grid: {
                            display: false
                        },
                    },
                    y: {
                        // type: '',
                        border: {
                            display: false
                        },
                        grid: {
                            // tickWidth: 45,
                            color: '#F1F1F1',
                            // tickLength: 45
                        },
                        ticks: {
                            callback: (value, index, values) => {
                                if (value == 0) return value + '   ';
                                return value / 1000 + 'k  ';
                            },
                            font: {
                                size: 14,
                            },
                            color: '#3e3e3e',
                            autoSkip: true,
                            maxTicksLimit: 5,
                        },

                    }
                },
                plugins: {
                    legend: {
                        title: {
                            display: true,
                            text: '',
                            padding: 20
                        },
                        position: 'bottom',
                        align: 'start',
                        labels: {
                            boxWidth: 18,
                            boxHeight: 18,
                            padding: 5,
                            useBorderRadius: true,
                            borderRadius: 9,
                            color: '#000000',
                            font: {
                                family: 'PPNV',
                                size: 14,
                                weight: 375,
                                lineHeight: '18px'
                            }
                        }
                    },
                    tooltip: {
                        callbacks: {
                            title: c => {
                                return c[0].dataset.xLabel;
                            },
                            label: c => {
                                return cryptoFormat.format(c.dataset.data) + ' ' + symbol;
                            },
                        },
                        font: {
                            family: "'PPNV', sans-serif"
                        },
                        titleFont: {
                            size: 16,
                            lineHeight: '19px',
                            weight: '400'
                        },
                        bodyFont: {
                            size: 14,
                            lineHeight: '14px'
                        },
                        backgroundColor: '#e7e7e7',
                        bodyColor: '#3e3e3e',
                        titleColor: '#3e3e3e',
                        useBorderRadius: true,
                        borderRadius: 10,
                        padding: 10,
                        yAlign: 'center',
                    }
                }
            }
        }
    )

}